<template>
    <div class="content">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询条件</span>
            </div>
            <div class="box-cont">
        <el-form :model="queryParams" ref="queryForm" :inline="true">
            <!-- <el-form-item label="地区">
                <el-select v-model="queryParams.shi" placeholder="请选择市" clearable size="small" style="width:120px;">
                    <el-option
                        v-for="dict in shiOptions"
                        :key="dict.id"
                        :label="dict.city"
                        :value="dict.city" @click.native="getxian(dict.id)"
                        ></el-option>
                </el-select>
                -
                <el-select v-model="queryParams.xianqu" placeholder="请选择县区" clearable :disabled="queryParams.shi?false:true" size="small" style="width:120px;">
                    <el-option
                        v-for="dict in xianquOptions"
                        :key="dict.id"
                        :label="dict.city"
                        :value="dict.city"
                        ></el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item label="监督对象:" prop="name">
                <el-input
                v-model="queryParams.name"
                placeholder="请输入监督对象"
                clearable
                size="small"
                @keyup.enter.native="handleQuery"
                />
            </el-form-item>
            <el-form-item label="案由:" prop="anyou">
                <el-input
                v-model="queryParams.anyou"
                placeholder="请输入案由"
                clearable
                size="small"
                @keyup.enter.native="handleQuery"
                />
            </el-form-item>
            <el-form-item label="上传日期:" prop="zylb">
                <el-date-picker size="small" clearable
                    v-model="queryParams.startDate"
                    type="date"
                    placeholder="选择日期" value-format="yyyy-MM-dd">
                </el-date-picker>
                至
                <el-date-picker size="small" clearable
                    v-model="queryParams.endDate"
                    type="date"
                    placeholder="选择日期" value-format="yyyy-MM-dd">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="提交状态:">
                <el-select v-model="queryParams.states" placeholder="请选择提交状态" clearable size="small" style="width:120px;">
                    <el-option label="未提交"  value="0"></el-option>
                    <el-option label="已提交"  value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">搜索</el-button>
                <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
                <el-button 
                type="danger"
                icon="el-icon-plus"
                size="small"
                @click="handleAdd"
                >新增案卷</el-button>
            </el-form-item>
        </el-form>
            </div>
        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询结果</span>
            </div>
            <div class="box-cont">
        <el-table v-loading="loading" :data="chackcaseList">
            <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="80">
                <template slot-scope="scope">
                    <span>{{(scope.$index+1) + ( queryParams.limit * (queryParams.page-1))}}</span>
                </template>
            </el-table-column>
            <el-table-column label="监督对象名称" prop="dwmc" key="dwmc" />
            <el-table-column label="立案日期" align="center" prop="lian_rq" key="lian_rq" >
                <template slot-scope="scope">
                    <span v-if="scope.row.lian_rq">{{ getDate2(scope.row.lian_rq) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="主办人" align="center" prop="host_man" width="180" key="host_man"  />
            <el-table-column label="协办人" align="center" prop="cooperate_man" width="180" key="cooperate_man"  />
            <el-table-column label="案由" prop="anyou" key="anyou" />
            <el-table-column label="上传日期" align="center" prop="creattime" key="creattime" >
                <template slot-scope="scope">
                    <span v-if="scope.row.creattime">{{ getDate2(scope.row.creattime)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="评查状态" align="center" prop="states" key="states" >
                <template slot-scope="scope">
                    <span v-if="scope.row.states == 1"><i style="width: 8px; height: 8px; display: inline-block; background: #1890ff; border-radius: 4px; margin-right: 5px;"></i>已提交</span>
                    <span v-else><i style="width: 8px; height: 8px; display: inline-block; background: #ff4a4a; border-radius: 4px; margin-right: 5px;"></i>未提交</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="220" >
                <template slot-scope="scope">
                <el-button v-if="scope.row.states != 1"
                    size="small"
                    type="text"
                    @click="getMulu(scope.row.lsh,scope.row.daLsh)"
                >目录</el-button>
                <el-button v-if="scope.row.states != 1"
                    size="small"
                    type="text"
                    @click="handleUp(scope.row.lsh)"
                >评查</el-button>
                <el-button 
                    size="small"
                    type="text"
                    @click="handleUpdate(scope.row)"
                >{{scope.row.states == 1 ? '查看':'修改'}}</el-button>
                <el-button v-if="scope.row.states != 1 && sc=='1'"
                    size="small"
                    type="text"
                    @click="handleDelete(scope.row.lsh)"
                >删除</el-button>
                <el-button
                    size="small"
                    type="text"
                    @click="handleShow(scope.row.lsh,scope.row.states)"
                >案件信息</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="page-part" style="padding:20px 20px 50px;">
            <el-pagination  v-if="pageshow"
                background
                @size-change='handleSizeChange'
                @current-change='handleCurrentChange'
                :current-page.sync="queryParams.page"
                :page-sizes="[10,20,30,40]"
                :page-size="queryParams.limit"
                layout="total, prev, pager, next, jumper"
                :total="total" style=" float:right;">
            </el-pagination>
        </div>
            </div>
        </el-card>

        <!-- 添加或修改用户对话框 -->
        <el-dialog title="上传案件" :visible.sync="openAj" top="20vh" width="600px" append-to-body :close-on-click-modal="false" class="newTk">
            <div class="nr">
                <el-form ref="form" :model="form" :rules="rules" label-width="100px" class="shangchuan">
                    <el-form-item label="案卷:">
                        <el-upload
                            class="upload-demo"
                            drag              :before-remove="handleRemove"          
                            action="#"  :before-upload="beforeUpload"
                             :file-list="fileList"  :limit="1" :on-exceed="handleExceed">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            <div class="el-upload__tip" slot="tip">仅支持pdf格式文件<br/>说明：扫描件300dpi以下，仅支持竖版</div>
                        </el-upload>
                        <p style="color: #ff0000;">{{errText}}</p>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer" style="text-align:right;">
                    <el-button @click="cancel">取消</el-button>
                    <el-button type="primary" @click="submitAj">识别案卷</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="案卷内容识别" v-loading="loading3" :visible.sync="open" top="8vh" width="85%" append-to-body class="newTk" :close-on-click-modal="false">
            <div class="nr">
                <p class="beizhu">注:系统智能识别后，部分文书未能智能识别，需进行人工识别。</p>
                <div class="cay" style="float:right;text-align: right;margin-top:-20px;" >
                    <el-button type="primary" size="small" @click="handleShow2(pcId,0)"  v-if="row.states != 1 || states == 0">案件信息</el-button>
                    <el-button type="success" size="small" @click="handleUp(pcId)"  v-if="row.states != 1 || states == 0">提交</el-button>
                    <el-button type="warning" size="small" @click="shuoming()">填写说明</el-button>
                </div>
                <div class="shibieW">
                    <div class="shibie left">
                        <h3>已识别部分</h3>
                        <div class="menus">
                            <el-scrollbar ref="myScrollbar">
                                <ul>
                                    <li v-for="(item,index) in identifyList" :key="index" :class="isIndex == index?'active':''" @click="showWs(item,index)" @contextmenu.prevent.stop="rightClick(item)" >
                                        <p><i class="el-icon-document"></i>&nbsp;{{ item.fileName }}</p>
                                    </li>
                                </ul>
                            </el-scrollbar>
                        </div>
                        <div class="imgW">
                            <el-scrollbar ref="myScrollbar2">
                                <p v-show="sbSrcs" v-for="(item,index) in sbSrcs" :key="index">
                                    <img :src="item" @dblclick="showBig(item)" />
                                </p>
                                <p v-show="sbSrc"><img :src="sbSrc" @dblclick="showBig(sbSrc)" /></p>
                                <el-button type="success" size="small" v-show="identifyList[isIndex]" @click="showText(1)" style="position: absolute; bottom: 15px; left: 10px;box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);">查看已识别内容</el-button>
                            </el-scrollbar>
                        </div>
                    </div>
                    <div class="shibie right">
                        <h3>未识别部分</h3>
                        <p v-show="identifyList2.length == 0" style="color:#67c23a;text-align: center; font-size: 16px; padding:30px;"><i class="el-icon-success"></i>该案件已识别完成!</p>
                        <div class="menus">
                            <el-scrollbar ref="myScrollbar3">
                                <ul>
                                    <li v-for="(item,index) in identifyList2" :key="index" :class="isIndex2 == index?'active':''" @click="showWs2(item,index)">
                                        <p><i class="el-icon-document"></i>&nbsp;{{ item.fileName == '' ? '未识别资料'+item.pageid : item.fileName }}</p>
                                    </li>
                                </ul>
                            </el-scrollbar>
                        </div>
                        <div class="imgW"  v-show="identifyList2.length > 0">
                            <el-scrollbar ref="myScrollbar4">
                                <h3><span>人工识别</span></h3>
                                <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                                    <el-form-item label="资料名称:" prop="fileName">
                                        <el-autocomplete style="width:calc(100% - 80px);"
                                            class="inline-input"
                                            v-model="form.fileName"
                                            :fetch-suggestions="querySearch"
                                            placeholder="请输入内容"
                                            :trigger-on-focus="false"
                                            @select="handleSelect"
                                            ></el-autocomplete>
                                        <el-button type="text" @click="lookFile">&nbsp;查看资料</el-button>
                                    </el-form-item>
                                    <el-form-item label="资料页数:" prop="pageCount">
                                        <el-input v-model="form.pageCount" style="width:100px;"></el-input>
                                        <span style="color: #ff0000;">&nbsp;* 请填写该资料总页数</span>
                                    </el-form-item>
                                    <el-form-item style="text-align:right;" v-if="row.states != 1">
                                        <el-button size="small" type="primary" @click="onSubmit">保存</el-button>
                                    </el-form-item>
                                    <!-- <el-form-item label="未识别提醒" v-if="cmid == '0000000'">
                                        <el-input type="textarea" disabled v-model="form.errlog"></el-input>
                                    </el-form-item> -->
                                    <el-form-item label="已识别内容:">
                                        <el-input type="textarea" rows="12" disabled v-model="content" @dblclick.native="showOpen4(content)"></el-input>
                                        <p style="color: #ff0000;line-height: 22px;">* 双击已识别内容放大</p>
                                    </el-form-item>
                                    <el-form-item label="" style="text-align:right;">
                                        <el-button type="primary" size="small" @click="lookFile">图片预览</el-button>
                                    </el-form-item>
                                    <!-- <el-form-item v-if="form.xiangmu && form.xiangmu.indexOf('A') != -1" label="以下空白">
                                        <el-radio-group v-model="form.kongbai" @input="newUpdate">
                                            <el-radio :label="1">合格</el-radio>
                                            <el-radio :label="0">不合格</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item v-if="form.xiangmu && form.xiangmu.indexOf('B') != -1" label="当事人签名">
                                        <el-radio-group v-model="form.qianzi" @input="newUpdate">
                                            <el-radio :label="1">合格</el-radio>
                                            <el-radio :label="0">不合格</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item v-if="form.xiangmu && form.xiangmu.indexOf('C') != -1" label="笔录属实">
                                        <el-radio-group v-model="form.shushi" @input="newUpdate">
                                            <el-radio :label="1">合格</el-radio>
                                            <el-radio :label="0">不合格</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item v-if="form.xiangmu && form.xiangmu.indexOf('D') != -1" label="当事人信息一致">
                                        <el-radio-group v-model="form.dwYz" @input="newUpdate">
                                            <el-radio :label="1">合格</el-radio>
                                            <el-radio :label="0">不合格</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item v-if="form.xiangmu && form.xiangmu.indexOf('E') != -1" label="有效盖章">
                                        <el-radio-group v-model="form.gaizhang" @input="newUpdate">
                                            <el-radio :label="1">合格</el-radio>
                                            <el-radio :label="0">不合格</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item v-if="form.xiangmu && form.xiangmu.indexOf('F') != -1" label="领导签名">
                                        <el-radio-group v-model="form.ldQianzi" @input="newUpdate">
                                            <el-radio :label="1">合格</el-radio>
                                            <el-radio :label="0">不合格</el-radio>
                                        </el-radio-group>
                                    </el-form-item> -->
                                </el-form>
                                
                                <!-- <el-button size="small" v-show="identifyList2[isIndex2]" type="success" @click="showText(2)"  style="position: absolute; bottom: 15px; left: 10px;box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);">查看已识别内容</el-button> -->
                            </el-scrollbar>
                        </div>
                    </div>
                    
                </div>
                <div class="btns" style=" text-align:right;padding-top: 20px;">
                    <el-button type="primary" size="small" @click="zancun"  v-if="row.states != 1 || states == 0" >刷新页面</el-button>
                    <el-button size="small" @click="cancel">取消</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="案卷识别文书" :visible.sync="open2" top="20px" :width="isH?'700px':'1200px'" append-to-body ref="rotate"  :close-on-click-modal="false">
            <div style="text-align: right;
    margin-right: 40px;
    position: absolute;
    right: 10px;
    top: 8px;"><el-button type="warning" size="small" @click="rotate">旋转</el-button></div>
            <p v-show="bigSrcs" v-for="(item,index) in bigSrcs" :key="index" :style="{'width':isH?'100%':'70%'}" style="margin: 0px auto;">
                <img :src="item" style="width: 100%;" />
            </p>
            <p v-show="bigSrc" ref="rotate" :style="{'width':isH?'100%':'70%'}" style="margin: 0px auto;"><img :src="bigSrc"  style="width: 100%;" /></p>
        </el-dialog>
        <el-dialog title="智能评查" :visible.sync="open3" top="5vh" width="90%" append-to-body class="pcTk" :close-on-click-modal="false">
            <znpc :pcId="this.pcId" :row="this.row" />
        </el-dialog>
        <div v-show="open4" class="tzbox" style="z-index: 9000; position: fixed;background: rgba(0,0,0,0.5); top: 0; right: 0; bottom: 0; left: 0; overflow: auto;  margin: 0;">
            <div style="width:800px; position: relative; z-index: 9999;top: 10vh; left: 50%; margin-left: -300px;height: auto;box-shadow: 0 1px 3px rgb(0 0 0 / 30%);">
                <vue-drag-resize :isActive="isActive" :isResizable="false" :preventActiveBehavior="true">
                    <h3 style="background: #e6e6e6;font-weight: normal; padding: 0px 20px 0px; line-height: 48px; border-radius: 4px 4px 0 0;">已识别内容
                    <i class="el-icon el-icon-close" @click="open4 = false" style="color: #909399;float:right;font-size:16px;margin-top: 18px;cursor: pointer;"></i></h3>
                    <div style="width:100%; background:#fff;padding:20px 0px 0; overflow: hidden;">
                        <label style="color:#ff0000; float:left; margin:0 10px 0 45px; font-weight: bold;">* 双击已识别文字{{isActive?'关闭':'开启'}}拖拽</label>
                        <el-switch v-model="isActive" active-text=""></el-switch></div>
                    <p  @dblclick="beginTz()" style="padding:15px 45px 40px;line-height:30px;font-size:15px;text-indent: 2rem;font-weight: bold; background: #fff; border-radius: 0 0 4px 4px;">{{ contentL }}</p>
                </vue-drag-resize>
            </div>
        </div>
        <el-dialog title="案卷详情" :visible.sync="open5" width="90%" top="2vh" append-to-body class="pcTk2" :close-on-click-modal="false">
            <ajxq :pcId="this.pcId" @callback="callback" :states="this.states" />
            
        </el-dialog>
        <el-dialog title="文书编辑" :visible.sync="open6" width="800px" append-to-body :close-on-click-modal="false">
            <el-form ref="formR" :model="formR" :rules="rules" label-width="110px">
                <el-form-item label="资料名称:" prop="fileName">
                    <el-input size="small" v-model="formR.fileName"></el-input>
                </el-form-item>
                <el-form-item label="资料页数:" prop="pageCount">
                    <el-input size="small" v-model="formR.pageCount"></el-input>
                </el-form-item>
                <el-form-item style="text-align:right;">
                    <el-button size="small" @click="cancel6">取消</el-button>
                    <el-button type="primary" size="small" @click="editDangan(0)">保存</el-button>
                    <el-button type="primary" size="small" @click="editDangan(1)">删除此文件</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <div v-show="loading2"  style="z-index: 9000; position: fixed;background: rgba(0,0,0,0.05); top: 0; right: 0; bottom: 0; left: 0; overflow: auto;  margin: 0;">
            <div class="load" style="position: absolute;padding-top: 40px; z-index: 2;    background: linear-gradient(128deg, rgb(255, 255, 255) 40%, rgb(230, 240, 252)); width: 700px; height: 400px; border-radius: 4px; top: 18vh; left: 50%;  margin-left: -350px;  text-align: center;">
                <img style="margin: 30px auto 30px;" src="../../../assets/images/loading.png" />
                <p style="font-weight: bold; font-size: 18px;">案卷正在上传解析中，预计需要3~5分钟,请不要关闭页面...</p>
            </div>
        </div>
        <el-dialog title="填写注意事项" :visible.sync="open7" top="8vh" width="1000px" append-to-body :close-on-click-modal="false">
            <div class="shuoming">
                <h2>浙江省案件质控系统文书识别注意事项</h2>
                <p>1.文书识别，并不能将所有文书全部由系统识别，对于系统无法自动识别的文书，需要人工协助。</p>
                <p>2.人工识别主要处理以下几种类型:a系统对某一个文书，只识别到其中1或者2页，其他续页没有识别。b系统对某一个文书，全部未识别。</p>
                <p>3.下面主要针对两种情况分开进行处理:</p>
                <p style="text-indent: 1rem;">A、只识别到其中1或者2页，其他续页没有识别’的处理</p>
                <p style="text-indent: 2rem;">举例说明:该文书（如行政处罚决定书，实际卷宗为4页，有2页已经识别到，在左侧，第3和4页无法识别，需要用手动识别处理）</p>
                <p style="text-indent: 2rem;">a.在资料名称中输入该文书名称，这时候常用文书中带有文书名称的的文书，会全部出现，这时候选择对应的文书 。</p>
                <p style="text-indent: 2rem;">b.接下来在资料页数中输入2（因为行政处罚决定书中未识别的部分仅剩两页，并且是连续的，所以输入2；如果不连续，只输入1即可），然后点击保存按钮，保存完后点击刷新页面即可。</p>
                <p style="text-indent: 2rem;">c.刷新完毕后，在左侧，已经识别部分会出现两个行政处罚决定书，第一个是对应文书的第1和第2页；第二个是对应文书的第3和第4页。这时候，在第一个文书已识别部分，<b style="background: #ffff00;">右键点击</b>，则会弹出文书编辑弹框，将资料页数由2改成4，就完成了将文书合并为一个文书的操作。之后点击保存，然后点击刷新页面，文书合并完成。</p>
                <p style="text-indent: 1rem;">B、系统对某一个文书（如询问笔录），全部未识别。</p>
                <p style="text-indent: 2rem;">a.在资料名称中输入询问，这时候常用文书中带有决定书的文书会全部出现，这时候选询问笔录。</p>
                <p style="text-indent: 2rem;">b.接下来在资料页数中输入2（因为询问笔录共2页，并且都未识别，所以输入2；如果不连续，只输入1即可），然后点击保存按钮，保存完后点击刷新页面即可。之后询问笔录会自动添加到左侧已经识别部分. </p>
            </div>
        </el-dialog>

        <el-dialog title="案卷目录" :visible.sync="openML" top="8vh" width="90%" append-to-body :close-on-click-modal="false">
            <div class="anjuan">
                <div class="imgs left2" >
                    <el-scrollbar ref="myScrollbar2">
                        <p v-show="sbSrcsN" v-for="(item,index) in sbSrcsN" :key="index">
                            <img :src="item" @dblclick="showBig(item)" />
                            <span>第&nbsp;{{index + 1}}&nbsp;页</span>
                        </p>
                    </el-scrollbar>
                </div>
                <div class="right2" v-loading="loadingMl">
                    <div class="mulu">
                        <el-table :data="mlList">
                            <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="60">
                                <template slot-scope="scope">
                                    <span>{{scope.$index+1}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="排序" align="center" prop="xuhao" width="100"  >
                                <template slot-scope="scope">
                                    <!-- <p class="btnS" style="position:relative; width:28px;height: 40px;float: left;">
                                        <span style="position: absolute;width: 28px;height: 15px;">
                                        <i @click="GoUp(scope.$index)" style="font-size:28px;color:#2a92eb;line-height:15px;" class="el-icon-caret-top"></i></span>
                                        <span style="position: absolute;width: 28px;height: 15px;top: 15px;z-index: 2;">
                                        <i @click="Godown(scope.$index)" style="font-size:28px;color:#2a92eb;line-height:15px;" class="el-icon-caret-bottom"></i></span>
                                    </p> -->
                                    <el-input 
                                        v-model.number="scope.row.orderNum" 
                                        size="small" 
                                        type="number" 
                                        min="1"
                                        :max="mlList.length || 1"
                                        @change="sortTable(scope.row, scope.$index)"
                                    ></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="题名" align="center" prop="title" >
                                <template slot-scope="scope">
                                    <el-input
                                        v-model="scope.row.title"
                                        placeholder=""
                                        clearable
                                        size="small"
                                        />
                                    
                                </template>
                            </el-table-column>
                            <el-table-column label="起始页" align="center" prop="pdfPage" width="100px" >
                                <template slot-scope="scope">
                                    <el-input
                                        v-model="scope.row.pdfPage"
                                        placeholder=""
                                        clearable
                                        size="small" 
                                        />
                                </template>
                            </el-table-column>
                            <el-table-column label="总页码数" align="center" prop="totalPages" width="100px" >
                                <template slot-scope="scope">
                                    <el-input
                                        v-model="scope.row.totalPages"
                                        clearable
                                        placeholder=""
                                        size="small" 
                                        />
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="180" >
                                <template slot-scope="scope">
                                    <el-button size="small" type="text" @click="sortMulu(scope.row)">重新整理目录</el-button>
                                    <el-button
                                        size="small"
                                        type="text"
                                        @click="handleAddMulu(scope.row,scope.$index)"
                                    >添加</el-button>
                                    <el-button
                                        size="small"
                                        type="text"
                                        @click="handleDeleteMulu(scope.$index)"
                                    >删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="btn">
                        <el-button size="small" type="primary" @click="subMulu(1)">保存</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>


        <el-dialog title="案卷内容识别" v-loading="loading3Yz" :visible.sync="openYz" top="8vh" width="85%" append-to-body class="newTk" :close-on-click-modal="false">
            <div class="nr">
                <p class="beizhu">注:系统智能识别后，部分文书未能智能识别，需进行人工识别。</p>
                <div class="cay" style="float:right;text-align: right;margin-top:-20px;" >
                    <el-button type="primary" size="small" @click="handleShow2(pcId,0)"  v-show="row.states != 1 ">案件信息</el-button>
                    <el-button type="success" size="small" @click="handleUp(pcId)"  v-show="row.states != 1 ">提交</el-button>
                    <el-button type="warning" size="small" @click="shuoming()">填写说明</el-button>
                </div>
                <div class="shibieW">
                    <div class="shibie left">
                        <h3>已识别部分</h3>
                        <div class="menus">
                            <el-scrollbar ref="myScrollbar">
                                <ul>
                                    <li v-for="(item,index) in identifyList" :key="index" :class="isIndex == index?'active':''" @click="showWsYz(item,index)" @contextmenu.prevent.stop="rightClickYz(item)" >
                                        <p><i class="el-icon-document"></i>&nbsp;{{ item.name}}</p>
                                    </li>
                                </ul>
                            </el-scrollbar>
                        </div>
                        <div class="imgW">
                            <el-scrollbar ref="myScrollbar2">
                                <p v-show="sbSrcs" v-for="(item,index) in sbSrcs" :key="index">
                                    <img :src="item.fileUrl" @dblclick="showBig(item.fileUrl)" />
                                </p>
                                <p v-show="sbSrc"><img :src="sbSrc" @dblclick="showBig(sbSrc)" /></p>
                                <el-button type="success" size="small" v-show="identifyList[isIndex]" @click="showTextYz(1)" style="position: absolute; bottom: 15px; left: 10px;box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);">查看已识别内容</el-button>
                            </el-scrollbar>
                        </div>
                    </div>
                    <div class="shibie right">
                        <h3>未识别部分</h3>
                        <p v-show=" identifyList2.length == 0" style="color:#67c23a;text-align: center; font-size: 16px; padding:30px;"><i class="el-icon-success"></i>该案件已识别完成!</p>
                        <div class="menus">
                            <el-scrollbar ref="myScrollbar3">
                                <ul>
                                    <li v-for="(item,index) in identifyList2" :key="index" :class="isIndex2 == index?'active':''" @click="showWsYz2(item,index)">
                                        <p><i class="el-icon-document"></i>&nbsp;{{ item.name == '' || item.name == null? '未识别资料'+item.qishiye : item.name }}</p>
                                    </li>
                                </ul>
                            </el-scrollbar>
                        </div>
                        <div class="imgW"  v-show="identifyList2 && identifyList2.length > 0">
                            <el-scrollbar ref="myScrollbar4">
                                <h3><span>人工识别</span></h3>
                                <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                                    <el-form-item label="资料名称:"  prop="name">
                                        <el-autocomplete style="width:calc(100% - 80px);"
                                            class="inline-input"
                                            v-model="form.name"
                                            :fetch-suggestions="querySearch"
                                            placeholder="请输入内容"
                                            :trigger-on-focus="false"
                                            @select="handleSelect"
                                            ></el-autocomplete>
                                        <el-button type="text" @click="lookFileYz">&nbsp;查看资料</el-button>
                                    </el-form-item>
                                    <!--0630<el-form-item label="资料名称:" v-else prop="fileName">
                                        <el-autocomplete style="width:calc(100% - 80px);"
                                            class="inline-input"
                                            v-model="form.fileName"
                                            :fetch-suggestions="querySearch"
                                            placeholder="请输入内容"
                                            :trigger-on-focus="false"
                                            @select="handleSelect"
                                            ></el-autocomplete>
                                        <el-button type="text" @click="lookFile">&nbsp;查看资料</el-button>
                                    </el-form-item>-->
                                    <el-form-item label="资料页数:" prop="pageCount">
                                        <el-input v-model="form.pageCount" style="width:100px;"></el-input>
                                        <span style="color: #ff0000;">&nbsp;* 请填写该资料总页数</span>
                                    </el-form-item>
                                    <el-form-item style="text-align:right;" v-if="row.states != 1">
                                        <el-button size="small" type="primary" @click="onSubmit">保存</el-button>
                                    </el-form-item>
                                    <!-- <el-form-item label="未识别提醒" v-if="cmid == '0000000'">
                                        <el-input type="textarea" disabled v-model="form.errlog"></el-input>
                                    </el-form-item> -->
                                    <el-form-item label="已识别内容:">
                                        <el-input type="textarea" rows="12" disabled v-model="content" @dblclick.native="showOpen4(content)"></el-input>
                                        <p style="color: #ff0000;line-height: 22px;">* 双击已识别内容放大</p>
                                    </el-form-item>
                                    <el-form-item label="" style="text-align:right;">
                                        <el-button type="primary" size="small" @click="lookFile">图片预览</el-button>
                                    </el-form-item>
                                    <!-- <el-form-item v-if="form.xiangmu && form.xiangmu.indexOf('A') != -1" label="以下空白">
                                        <el-radio-group v-model="form.kongbai" @input="newUpdate">
                                            <el-radio :label="1">合格</el-radio>
                                            <el-radio :label="0">不合格</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item v-if="form.xiangmu && form.xiangmu.indexOf('B') != -1" label="当事人签名">
                                        <el-radio-group v-model="form.qianzi" @input="newUpdate">
                                            <el-radio :label="1">合格</el-radio>
                                            <el-radio :label="0">不合格</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item v-if="form.xiangmu && form.xiangmu.indexOf('C') != -1" label="笔录属实">
                                        <el-radio-group v-model="form.shushi" @input="newUpdate">
                                            <el-radio :label="1">合格</el-radio>
                                            <el-radio :label="0">不合格</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item v-if="form.xiangmu && form.xiangmu.indexOf('D') != -1" label="当事人信息一致">
                                        <el-radio-group v-model="form.dwYz" @input="newUpdate">
                                            <el-radio :label="1">合格</el-radio>
                                            <el-radio :label="0">不合格</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item v-if="form.xiangmu && form.xiangmu.indexOf('E') != -1" label="有效盖章">
                                        <el-radio-group v-model="form.gaizhang" @input="newUpdate">
                                            <el-radio :label="1">合格</el-radio>
                                            <el-radio :label="0">不合格</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item v-if="form.xiangmu && form.xiangmu.indexOf('F') != -1" label="领导签名">
                                        <el-radio-group v-model="form.ldQianzi" @input="newUpdate">
                                            <el-radio :label="1">合格</el-radio>
                                            <el-radio :label="0">不合格</el-radio>
                                        </el-radio-group>
                                    </el-form-item> -->
                                </el-form>
                                
                                <!-- <el-button size="small" v-show="identifyList2[isIndex2]" type="success" @click="showTextYz(2)"  style="position: absolute; bottom: 15px; left: 10px;box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);">查看已识别内容</el-button> -->
                            </el-scrollbar>
                        </div>
                    </div>
                    
                </div>
                <div class="btns" style=" text-align:right;padding-top: 20px;">
                    <el-button type="primary" size="small" @click="zancunYz"  v-show="row.states != 1" >刷新页面</el-button>
                    <el-button size="small" @click="cancel">取消</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="文书编辑" :visible.sync="open6Yz" width="800px" append-to-body :close-on-click-modal="false">
            <el-form ref="formR" :model="formR" :rules="rules" label-width="110px">
                <el-form-item label="资料名称:" prop="name">
                    <el-input size="small" v-model="formR.name"></el-input>
                </el-form-item>
                <el-form-item label="资料页数:" prop="pageCount">
                    <el-input size="small" v-model="formR.pageCount"></el-input>
                </el-form-item>
                <el-form-item style="text-align:right;">
                    <el-button size="small" @click="open6Yz = false">取消</el-button>
                    <el-button type="primary" size="small" @click="editDanganYz(0)">保存</el-button>
                    <el-button type="primary" size="small" @click="editDanganYz(1)">删除此文件</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>


<script> 
import VueDragResize from 'vue-drag-resize';
import Ajxq from '../ajpc/ajxq.vue'
import Znpc from '../ajpc/znpc.vue'
import axios from 'axios'
import qs from 'qs'
export default {
    name: "Layout",
    data() {
        return {
            loading:false,
            loading2:false,
            loading3:false,
            cmid:'',
            dm:'',
            xianqu:'',
            queryParams:{
                name:'',
                anyou:'',
                startDate:'',
                endDate:'',
                page:1,
                limit:10,
                shi:'',
                xianqu:'',
                states:'',
                isPingce:''
            },
            times:[],
            times2:[],
            total:0,
            chackcaseList:[],
            form:{},
            open: false,
            openAj: false,
            tpbase:'',
            fileName:'',
            files:{},
            sbFile:'',
            sbSrc:'',
            sbSrcs:[],
            sbSrcN:'',
            sbSrcsN:[],
            mlList:[],
            identifyList:[],
            isIndex:0,
            identifyList2:[],
            isIndex2:0,
            bigSrc:'',
            bigSrcs:[],
            open2:false,
            fileList: [],
            pcId:'',
            rules: {
                fileName: [{ required: true, message: "资料名称不能为空", trigger: "blur" }],
                pageCount: [{ required: true, message: "资料页数不能为空", trigger: "blur" }],
            },
            projects:[],
            total:0,
            open3:false,
            content:'',
            open4:false,
            contentL:'',
            row:{},
            open5:false,
            formDw:{},
            formR:{},
            open6:false,
            restaurants: [],
            pageshow:true,
            anyou2:'',
            open7:false,
            pcId2:'',
            deg:0,
            isH:true,
            isActive:true,
            states:0,
            shiOptions:[],
            xianquOptions:[],
            sc: "",
            xg: "",
            xz: "",
            errText:'',
            openML:false,
            loadingMl:false,
            pdfUrl:'',
            openYz:false,
            loading3Yz:false,
            open6Yz:false,
            isJiexi:true,
            baseUrl:''
        }
    },

    components: {
        Ajxq,
        Znpc,
        VueDragResize
    },
    computed: {
    },
    created() {
    },
    mounted() {
        let quxian = JSON.parse(sessionStorage.getItem("quxiandata"));
        console.log(quxian)
        if(quxian && quxian.length > 0){
            quxian.forEach(ele=> {
                if(ele.item == '案卷智能解析'){
                    this.sc = ele.sc
                    this.xg = ele.xg
                    this.xz = ele.xz
                }
            })
        }
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.dm = user.dm
        this.cmid = user.c_mid
        this.xianqu = user.xianqu
        this.baseUrl = user.baseUrl
        let yy = (new Date()).getFullYear()
        let mm1=this.Time(new Date(new Date().getFullYear(),new Date().getMonth()-1,new Date().getDate()));
        let mm = (new Date()).getMonth() + 1
        let dd = (new Date()).getDate()
        this.times = mm1
        this.times2 = yy+'-' + mm + '-' + dd
        this.$set(this.queryParams, 'startDate', this.times)
        this.$set(this.queryParams, 'endDate', this.times2)
        this.$forceUpdate()
        this.getList()
    },
    methods: {
        Time(now) {

            let year=new Date(now).getFullYear();

            let month=new Date(now).getMonth()+1;
            let date=new Date(now).getDate();
            if (month < 10) month = "0" + month;
            if (date < 10) date = "0" + date;
            return year+"-"+month+"-"+date
        },
        beginTz(){
            this.isActive = !this.isActive
        },
        callback(val){
            this.open5 = false
        },
        async querySearch(queryString, cb) {
            let data = await this.$axios.get(`${this.Global._baseUrl}?act=getWslist&name=${escape(queryString)}`)
            if(data.data != -1 && data.data != ''){
                this.restaurants = data.data
                this.restaurants.forEach(item => {
                    item.value = item.mc
                })
                var restaurants = this.restaurants;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 调用 callback 返回建议列表的数据
                cb(results);
            }else{
                var results = []
                cb(results);
            }
        },
        createFilter(queryString) {
            return (restaurant) => {
            return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) != '-1');
            };
        },
        handleSelect(item) {
            this.form.fileName = item.value
        },
        getList(){
            this.queryParams.startDate = this.queryParams.startDate ? this.queryParams.startDate : this.times
            this.queryParams.endDate = this.queryParams.endDate ? this.queryParams.endDate : this.times2
            this.queryParams.xianqu = this.queryParams.shi ? this.queryParams.xianqu : ''
            let dm = this.queryParams.shi ? '' :this.dm
            let page = this.queryParams.page
            this.chackcaseList = []
            this.total = 0
            this.loading = true
            axios({
                method: 'post',
                url: this.baseUrl+`/login/getAnjiannList`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    dwmc: this.queryParams.name,
                    anyou:this.queryParams.anyou ,
                    cmid: this.cmid,
                    startDate:this.getDate(this.queryParams.startDate,'yyyy-MM-dd') ,
                    endDate: this.getDate(this.queryParams.endDate,'yyyy-MM-dd'),
                    states: '',
                    dm: dm,
                    shi: this.queryParams.shi,
                    xianqu: this.queryParams.xianqu,
                    isPingce: '',
                    type: 1,
                    pageSize: this.queryParams.limit,
                    pageNum: this.queryParams.page
                }
            })
            .then(response => {
                console.log(response.data);
                this.chackcaseList = response.data.data.list || []
                this.total = response.data.data.total || 0
                this.loading = false
            })
            .catch(error => {
                this.loading = false
                this.$message.error('获取数据失败！');
                console.error('There was an error!', error);
            });
        },
        handleAdd(){
            this.openAj = true
            this.fileList = []
            this.fileName = ""
            this.files = {}
        },
        handleQuery(){
            this.pageshow = false;
            this.queryParams.page = 1
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        resetQuery(){
            this.queryParams.page = 1
            this.queryParams = {
                name:'',
                anyou:'',
                startDate:'',
                endDate:'',
                page:1,
                limit:10,
                shi:'',
                xianqu:'',
                states:'',
                isPingce:''
            }
            this.getList()
        }, 
        beforeUpload(file){
            this.fileList = []
            this.files = file;
            const extension = file.name.split('.')[1] === 'pdf'
            // const isLt2M = file.size / 1024 / 1024 < 5
            if (!extension) {
            this.$message.warning('上传模板只能是 pdf格式!')
            return
            }
            // if (!isLt2M) {
            // this.$message.warning('上传模板大小不能超过 5MB!')
            // return
            // }
            this.fileList.push({name:file.name}) 
            this.fileName = file.name;
            return false // 返回false不会自动上传
        }, 
        handleRemove(file, fileList) {
            if(file.status == 'success'){
                if(this.fileList.length > 1){
                    let isy = this.fileList.findIndex(item => {
                        return item.name == file.name
                    })
                    if(isy != -1){
                        this.fileList.splice(isy,1) 
                    }
                }
            }
        },
        handleExceed(files, fileList) {
            this.$message.warning('只能上传一个文件，请先删除已上传的文件再尝试上传新文件。');
        },
        async submitAj(){
            this.loading2 = true
            if(this.fileName == ""){
                this.$message.warning('请选择要上传的文件！')
                return false
            }
            let fileFormData = new FormData();
            fileFormData.append('file', this.files);//filename是键，file是值，就是要传的文件，test.zip是要传的文件名
            fileFormData.append('fileName', this.fileName);
            let config = {
                headers: {
                'Content-Type': 'multipart/form-data'
                },
            }
            this.$axios.post(this.baseUrl+`/login/uploadXcFile2`,fileFormData, config)
            .then(res => {
                if(res.data.code == 0){
                    this.sbFile = res.data.filenewname[0].newFileName
                    this.getNew2Yz(this.sbFile)
                }
            }).catch(err => {
                this.$message({
                    message: '上传失败，请重新选择案卷',
                    type: 'error'
                });
                this.loading2 = false
            })	
		},
        async getNew2(file){
            console.log('20250224新接口解析......')
            this.loading2 = true
            this.errText = ''
            this.sbSrc = ''
            this.pcId = ''
            this.sbSrcs = []
            this.identifyList = []
            this.identifyList2 = []
            let url = ''
            axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: this.baseUrl+`/pdfApi/getDanganJiexiToImage`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    pcId:'',
                    strFile:file,
                    dm:this.dm,
                    cmid:this.cmid,
                    type:1
                }
            })
            .then(res => {
                console.log(res,663)
                
                if(res.data.code == 0){
                        //this.pcId = res.data.filenewname[0].id

                        this.pcId = res.data.msg
                        this.getJiexi(this.pcId)
                }else{
                    this.loading2 = false
                    this.$message({
                        message: res.data.msg,
                        duration: 10000,
                        type: 'error'
                    });
                    this.errText = '错误提示：' + res.data.msg
                }
            })
            .catch(error => {
                this.loading2 = false
                this.$message({
                    message: error.data.msg ? error.data.msg : '解析失败，请重试！',
                    duration: 5000,
                    type: 'error'
                });
            });
        },
        async getNew2Yz(file){
            console.log('20250224新接口解析......')
            this.loading2 = true
            this.errText = ''
            this.sbSrc = ''
            this.pcId = ''
            this.sbSrcs = []
            this.identifyList = []
            this.identifyList2 = []
            axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: this.baseUrl+`/yz/pdfToChaiToMuLu`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    pcId:'',
                    strFile:file,
                    dm:this.dm,
                    cmid:this.cmid,
                    type:1
                }
            })
            .then(res => {
                console.log(res,663)
                
                if(res.data.code == 0){
                        
                        let arr = res.data.data.imgUrl
                        this.pdfUrl = res.data.data.pdfUrl
                        let http = res.data.data.pdfUrl.split('.pdf')[0]
                        this.sbSrcsN = []

                        arr.forEach(item=>{
                            let imgUrl = http+'/'+item.fileName
                            this.sbSrcsN.push(imgUrl)
                        })
                        let arrM = res.data.data.mulu
                        this.mlList = []
                        arrM.forEach((item,index) => {
                            item.orderNum = index + 1
                            this.mlList.push(item)
                        })
                        this.pcId = res.data.data.pcId
                        this.loading2 = false
                        this.openAj = false
                        this.openML = true
                        console.log(this.sbFile,2)
                        if(this.openML){
                            this.subMulu(2)
                        }
                }else{
                    this.loading2 = false
                    this.$message({
                        message: res.data.msg,
                        duration: 10000,
                        type: 'error'
                    });
                    
                }
            })
            .catch(error => {
                this.loading2 = false
                this.$message({
                    message: error.data.msg ? error.data.msg : '解析失败，请重试！',
                    duration: 5000,
                    type: 'error'
                });
            });
        },
        getMulu(pcId,daLsh){
            this.sbFile = daLsh + '.pdf'
            this.pcId = pcId
            console.log(this.sbFile,1392,this.pcId)
            this.loading = true
            axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: this.baseUrl+`/yz/muLuList`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    pcId:pcId,
                }
            })
            .then(res => {
                this.loading = false
                console.log(res,123)
                if(res.data.code == 0){
                    let arr = res.data.data.imgUrl
                    this.pdfUrl = res.data.data.pdfUrl
                    let http = res.data.data.pdfUrl.split('.pdf')[0]
                    this.sbSrcsN = []

                    arr.forEach(item=>{
                        let imgUrl = http+'/'+item.fileName
                        this.sbSrcsN.push(imgUrl)
                    })
                    let arrM = res.data.data.mulu || []
                    this.mlList = []
                    console.log(1416,arrM)
                    if(arrM && arrM.length > 0 ){
                        if(arrM[0].title){
                            console.log(1418)
                            arrM.forEach((item,index) => {
                                item.orderNum = index + 1
                                this.mlList.push(item)
                            })
                        }
                    }
                    this.pcId = res.data.data.pcId
                    this.openML = true
                }else{
                    this.$message({
                        message: res.data.msg,
                        duration: 10000,
                        type: 'error'
                    });
                }
            })
        },
        async subMulu(val){
            this.loadingMl = true
            this.mlList.forEach(item=>{
                item.pcId = this.pcId
            })
            axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: this.baseUrl+`/yz/saveMuUpdate`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data:this.mlList
            })
            .then(res => {
                console.log(res,1242)
                this.loadingMl = false
                console.log(this.sbFile,3)
                if(res.data.msg == '操作成功' && val != 2){
                    this.EndJiexi()
                }
            })
            .catch(error => {
                this.loadingMl = true
                this.$message({
                    message: error.data.msg ? error.data.msg : '解析失败，请重试！',
                    duration: 5000,
                    type: 'error'
                });
            });
        },
        //重新整理目录
        sortMulu(row){
            this.loadingMl = true
            
            this.mlList.forEach(item=>{
                item.type = 0
                if(item.title == row.title){
                    item.type = 1
                }
            })
            axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: this.baseUrl+`/yz/refreshMuLu`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data:this.mlList
            })
            .then(res => {
                console.log(res,1242)
                this.loadingMl = false
                console.log(this.sbFile,3)
                if(res.data.code == 0){
                    this.mlList = res.data.data
                }
            })
            .catch(error => {
                this.loadingMl = true
                this.$message({
                    message: error.data.msg ? error.data.msg : '解析失败，请重试！',
                    duration: 5000,
                    type: 'error'
                });
            });
        },
        async EndJiexi(){
            console.log(123456)
            this.$confirm('目录已修改成功, 是否立即开始解析案卷材料?', '提示', {
                confirmButtonText: '解析',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.EndJiexiYz()
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消解析，重新修改目录'
                });          
            });
        },
        async EndJiexiYz(){
            console.log(this.sbFile,4)
            this.loadingMl = true
            console.log('20250424仪征新接口解析......')
            axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: this.baseUrl+`/yz/ocrAnJuan`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    pcId:this.pcId,
                    pdfUrl:this.sbFile,
                }
            })
            .then(res => {
                console.log(res,1300)
                if(res.data.code == 0 && res.data.msg == '操作成功'){
                    this.danganJiexiYz()
                    this.getList()
                }else{
                    this.loadingMl = false
                    this.$message({
                        message: '解析失败，请仔细检查目录',
                        duration: 10000,
                        type: 'error'
                    });
                }
            })
            .catch(error => {
                this.loading2 = false
                this.$message({
                    message: error.data.msg ? error.data.msg : '解析失败，请重试！',
                    duration: 5000,
                    type: 'error'
                });
            });
        },
        async danganJiexiYz(){
            this.loading3Yz = true
            this.loading = true
            this.errText = ''
            this.sbSrc = ''
            this.sbSrcs = []
            this.identifyList = []
            this.identifyList2 = []
            axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: this.baseUrl+`/yz/getDanganList`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    pcId:this.pcId
                }
            })
            .then(res => {
                this.loading = false
                this.loadingMl = false
                console.log(res,1496)
                this.loading3Yz = false
                this.isIndex = 0
                this.isIndex2 = 0
                console.log(res.data,15000)
                if(res.data && res.data.data){
                    let data = res.data.data
                    this.identifyList = data.danganList
                    console.log(this.identifyList,1500)
                    console.log(this.identifyList.length)
                    if(this.identifyList && this.identifyList.length > 0){
                        this.openYz = true
                        this.openML = false
                        console.log(this.identifyList[0],1502)
                        if(this.identifyList[0].pageCount == 1){
                            console.log(this.identifyList[0].fileUrlsList)
                            this.sbSrc = this.identifyList[0].fileUrlsList[0].fileUrl
                        }else{
                            this.sbSrcs = this.identifyList[0].fileUrlsList
                        }
                    }else{
                        this.$message.error('解析失败，请重试！')
                    }
                    this.identifyList2 = data.weidanganList
                    console.log(this.identifyList2,1347)
                    console.log(this.identifyList2.length)
                    if(this.identifyList2 && this.identifyList2.length > 0){
                        console.log(123)
                        let form = this.identifyList2[0]

                        form.pageCount = form.pageCount ? form.pageCount : 1
                        form.errlog = form.errlog ? form.errlog : '无法识别文件名称'  
                        this.form = form
                        this.content = ''
                        this.showTextYz(2)
                    }                    
                }                                
            })
            .catch(error => {
                this.loading = false
                this.loadingMl = false
                this.$message({
                    message: '解析失败，请重试！',
                    duration: 5000,
                    type: 'error'
                });
            });
        },
        showWsYz(val,index){
            // 回到顶部
            console.log(val,index,1516)
            this.$refs.myScrollbar2.wrap.scrollTop= 0;
            this.sbSrc = ''
            this.sbSrcs = []
            this.isIndex = index
            if(val.pageCount == 1){
                this.sbSrc = val.fileUrlsList[0].fileUrl
                console.log(this.sbSrc,1520)
            }else{
                this.sbSrcs = val.fileUrlsList

            }
        },
        showTextYz(val){
            this.contentL = ''
            let arr = []

            if(val == 1 && this.identifyList[this.isIndex]){
                arr = this.identifyList[this.isIndex].fileUrlsList
            }else if(val == 2 && this.identifyList2[this.isIndex2]){
                arr = this.identifyList2[this.isIndex2].fileUrlsList
            }
            if(val == 1){
                this.contentL = ''
                arr.forEach(item => {
                    this.contentL += item.nr2 
                })
                this.open4 = true
            }else if(val == 2){
                this.content = ''
                arr.forEach(item => {
                    this.content += item.nr2
                })
                this.$forceUpdate()
            }
        },
        showWsYz2(item,index){
            this.form = {}
            this.content = ''
            this.isIndex2 = index
            let form = item
            form.pageCount = form.pageCount ? form.pageCount : 1
            form.errlog = form.errlog ? form.errlog : '无法识别文件名称' 
            this.form = form
            this.showTextYz(2)
        },
        rightClickYz(item){
            if(this.row.states != 1){
                this.formR = item
                this.open6Yz = true
            }else{
                this.$message({
                    message: '该案卷已提交，不能再进行修改！',
                    type: 'error'
                });
            }
        },
        async EndJiexiYzYuan(){
            console.log('20250424仪征新接口解析......')
            this.errText = ''
            this.sbSrc = ''
            this.sbSrcs = []
            this.identifyList = []
            this.identifyList2 = []
            axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: this.baseUrl+`/yz/pdfToChaiToAiLi`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    pcId:'',
                    strFile:this.sbFile,
                    dm:this.dm,
                    cmid:this.cmid,
                    type:1
                }
            })
            .then(res => {
                console.log(res,663)
                if(res.data.code == 0){
                    //this.pcId = res.data.filenewname[0].id
                    this.pcId = res.data.msg
                    this.getJiexi(this.pcId)
                }else{
                    this.loading2 = false
                    this.$message({
                        message: res.data.msg,
                        duration: 10000,
                        type: 'error'
                    });
                    
                }
            })
            .catch(error => {
                this.loading2 = false
                this.$message({
                    message: error.data.msg ? error.data.msg : '解析失败，请重试！',
                    duration: 5000,
                    type: 'error'
                });
            });
        },
        async getNew(file){
            this.loading2 = true
            this.sbSrc = ''
            this.pcId = ''
            this.sbSrcs = []
            this.identifyList = []
            this.identifyList2 = []
            this.$axios.get(`${this.Global._baseUrl}?act=getDanganJiexi&pcId=&strFile=${file}&dm=${this.dm}`)
            .then(res => {
                if(res.data.error == 0){
                    this.pcId = res.data.filenewname[0].id
                    this.getJiexi(this.pcId)
                }else{
                    this.$message({
                        message: res.data.msg,
                        duration: 5000,
                        type: 'error'
                    });
                    this.loading2 = false
                }
            }).catch(err => {
                this.$message({
                    message: err.data.msg,
                    duration: 5000,
                    type: 'error'
                });
                this.loading2 = false
            })	
        },
        async getJiexi(pcId){
            let data2 = await this.$axios.get(`${this.Global._baseUrl}?act=getDanganList&pcId=${pcId}&dalsh=`)
            if(data2.data.code != -1){
                this.loading2 = false
                this.states = (this.row && this.row.states==1) ? 1 : 0
                this.open = true
                this.openAj = false
                this.getXq(data2.data)
                this.getList()
            }else{
                this.$message({
                    message: '解析出错，请重新上传！',
                    type: 'error'
                });
                this.loading2 = false
            }
        },
        getXq(data){
            this.identifyList = data.good
            if(this.identifyList[0]){
                if(this.identifyList[0].pageCount == 1){
                    this.sbSrc = 'https://dapc1.scqwszfd.cn:8123/zfjl/dianzidangan/' + this.identifyList[0].nian + '/'+this.identifyList[0].dalsh+'/anjian'+(this.identifyList[0].pageid == 1?1:this.identifyList[0].pageid)+'.jpg'
                }else{
                    let mm = Number(this.identifyList[0].pageid)+Number(this.identifyList[0].pageCount)
                    for(var i=this.identifyList[0].pageid;i<mm;i++){
                        let src = 'https://dapc1.scqwszfd.cn:8123/zfjl/dianzidangan/' + this.identifyList[0].nian + '/'+this.identifyList[0].dalsh+'/anjian'+(i == 1?1:i)+'.jpg'
                        this.sbSrcs.push(src)
                    }
                }
            }
            this.identifyList2 = data.error
            if(this.identifyList2[0]){
                let form = this.identifyList2[0]
                form.pageCount = form.pageCount ? form.pageCount : 1
                form.errlog = form.errlog ? form.errlog : '无法识别文件名称'
                // if(form.xiangmu){
                //     this.getXiangmu(form)
                // }    
                this.form = form
                this.content = ''
                this.showText(2)
            }
        },
        newUpdate(){
            this.$forceUpdate();
        },
        getXiangmu(form){
            let obj = { 'A': '以下空白', 'B': '当事人签名', 'C': '笔录属实', 'D': '当事人信息一致', 'E': '有效盖章', 'F':'领导签名' }
            let mc = { 'A': 'yxkb', 'B': 'dsrqm', 'C': 'blss', 'D': 'dsrxxyz', 'E': 'yxgz', 'F': 'ldqm' }
            let pysx = { 'A': 'kongbai', 'B': 'qianzi', 'C': 'shushi', 'D': 'dwYz', 'E': 'gaizhang', 'F':'ldQianzi' }
            let arr = ['A','B','C','D','E','F']
            this.projects = []
            arr.forEach(item => {
                if(form.xiangmu.indexOf(item) != -1){
                    this.projects.push(pysx[item])
                    let vkey = pysx[item]
                    form[vkey] = 0
                    if(form.val){
                        let arr2 = form.val
                        arr2.forEach(itema => {
                            if(itema.jieguo == obj[item]){
                                form[vkey] = 1
                            }
                        })
                    }
                }
            })
        },
        async onSubmit(){
            let objAll = {}
            // if(this.form.kongbai || this.form.qianzi || this.form.shushi || this.form.dwYz || this.form.gaizhang || this.form.ldQianzi){
            //     let obj = { 'A': '以下空白', 'B': '当事人签名', 'C': '笔录属实', 'D': '当事人信息一致', 'E': '有效盖章', 'F':'领导签名' }
            //     let mc = { 'A': 'yxkb', 'B': 'dsrqm', 'C': 'blss', 'D': 'dsrxxyz', 'E': 'yxgz', 'F': 'ldqm' }
            //     let pysx = { 'A': 'kongbai', 'B': 'qianzi', 'C': 'shushi', 'D': 'dwYz', 'E': 'gaizhang', 'F':'ldQianzi' }
            //     let arr = ['A','B','C','D','E','F']
            //     console.log(this.projects)
            //     this.projects.forEach(item => {
            //         console.log(item)
            //         objAll[item] = this.form[item]
            //     })
            //     console.log(objAll,'0000')
            // }
            let wsPageNum = this.form.pageCount
            let data = await this.$axios.get(`${this.Global._baseUrl}?act=setJxWsList&pcId=${this.pcId}&name=${escape(this.form.fileName)}&jieguo=&wsPageId=${this.form.pageid}&wsPageNum=${wsPageNum}`)
            if (data.data == 1) {
                this.$message({
                    message: '保存成功',
                    type: 'success'
                });
                // if (num == $('.content_main_radio input:radio:checked').length && name != '' && pageCount != '') {
                //     $('#middle .middle_part .list_right li.active').remove()
                //     if ($('#middle .middle_part .list_right li').length != 0) {
                //         getws2($('#middle .middle_part .list_right li').eq(0))
                //         //$('#middle .middle_part .list_right li').eq(0).addClass('active').siblings().removeClass("active");
                //     } else {
                //         $('.content_main').css('display','none')
                //     }
                // }
            } else {
                this.$message({
                    message: '保存失败',
                    type: 'error'
                });
            }
        },
        showWs(val,index){
            // 回到顶部
            this.$refs.myScrollbar2.wrap.scrollTop= 0;
            this.sbSrc = ''
            this.sbSrcs = []
            this.isIndex = index
            if(val.pageCount == 1){
                this.sbSrc = 'https://dapc1.scqwszfd.cn:8123/zfjl/dianzidangan/' + val.nian + '/'+val.dalsh+'/anjian'+(val.pageid == 1?1:val.pageid)+'.jpg'
            }else{
                let mm = Number(val.pageid)+Number(val.pageCount)
                for(var i=val.pageid;i<mm;i++){
                    let src = 'https://dapc1.scqwszfd.cn:8123/zfjl/dianzidangan/' + val.nian + '/'+val.dalsh+'/anjian'+(i == 1?1:i)+'.jpg'
                    this.sbSrcs.push(src)
                }
            }
        },
        lookFile(){
            this.bigSrc = ''
            this.bigSrcs = []
            let val = this.form
            if(val.pageid.indexOf('||') == -1){
                this.bigSrc = 'https://dapc1.scqwszfd.cn:8123/zfjl/dianzidangan/' + val.nian + '/'+val.dalsh+'/anjian'+(val.pageid == 1?1:val.pageid)+'.jpg'
            }else{
                let newId = val.pageid.split('||')
                newId.forEach(item => {
                    let src = 'https://dapc1.scqwszfd.cn:8123/zfjl/dianzidangan/' + val.nian + '/'+val.dalsh+'/anjian'+(item == 1?1:item)+'.jpg'
                    this.bigSrcs.push(src)
                })
            }
            this.open2 = true
            this.isH = true
            this.$refs.rotate.style.transform = `rotate(0deg)`
        },
        lookFileYz(){
            this.bigSrc = ''
            this.bigSrcs = []
            let val = this.form
            this.bigSrc = this.form.fileUrlsList[0].fileUrl
            this.open2 = true
            this.isH = true
            this.$refs.rotate.style.transform = `rotate(0deg)`
        },
        // 旋转图片
        rotate () {
            this.isH = false
            this.deg += 90
            if (this.deg >= 360) {
                this.deg = 0
            }
            this.$refs.rotate.style.transform = `rotate(${this.deg}deg)`
        },
        showWs2(item,index){
            this.form = {}
            this.content = ''
            this.isIndex2 = index
            let form = item
            form.pageCount = form.pageCount ? form.pageCount : 1
            form.errlog = form.errlog ? form.errlog : '无法识别文件名称'
            // if(form.xiangmu){
            //     this.getXiangmu(form)
            // }    
            this.form = form
            this.showText(2)
        },
        showBig(src){
            this.bigSrc = src
            this.open2 = true
            this.isH = true
            this.$refs.rotate.style.transform = `rotate(0deg)`
        },
        cancel(){
            this.reset()
            this.open = false
            this.open2 = false
            this.openAj = false
            this.openML = false
            this.openYz = false
        },
        cancel6(){
            this.open6 = false
        },
        reset(){
            this.form = {}
            this.bigSrc = ''
            this.bigSrcs = []
            this.sbSrc = ''
            this.sbSrcs = []
            this.identifyList = []
            this.identifyList2 = []
        },
        async zancun(){
            this.reset()
            this.loading3 = true
            let data = await this.$axios.get(`${this.Global._baseUrl}?act=getChongxinZhengli&pcId=${this.pcId}`)
            if(data.data){
                this.isIndex = 0
                this.isIndex2 = 0
                this.getXq(data.data)
            }
            this.loading3 = false
        },
        async handleUp(lsh){
            this.$confirm("请先点击案件详情确认所有信息后再提交，提交后将不能再编辑。是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(async () => {
                axios({
                    method: 'post',
                    url: this.baseUrl+`/login/setAnjianStates`,
                    data:{
                        pcId: lsh,
                        states:1,
                    },
                    headers: { 
                        "Content-Type": "application/json"
                    },
                }).then(res => {
                    if(res.data.code == 0){
                        this.open = false
                        this.openML = false
                        this.openYz = false
                        this.getList()
                    }else{
                        this.$message({
                            message: res.data.data+',提交失败，请重新操作！',
                            type: 'error'
                        });
                        setTimeout(()=>{
                            this.handleShow(lsh,0)
                        },1000)
                    }
                }).catch(error => {
                    this.$message.error(error);
                })
            })
        },
        shuoming(){
            this.open7 = true
        },
        handleUpdate(row){
            this.reset()
            this.row = row
            this.content = ''
            this.pcId = row.lsh
            this.sbFile = row.daLsh+'.pdf'
            this.danganJiexiYz()
        },
        handleDelete(lsh){
            this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(async () => {
                this.$axios.get(`${this.Global._baseUrl}?act=delAnjiann&pcId=${lsh}`)
                .then(res => {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.getList()  
                }).catch(err => {
                    this.$message({
                        message: '删除失败',
                        type: 'error'
                    });
                })	
                    
            })
            .catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消删除"
                });
            });			
        },
        handleShow(lsh,val){
            this.pcId = lsh
            this.states = val || 0
            this.open5 = true
        },
        handleShow2(pcId,val){
            console.log(pcId,this.pcId)
            this.states = val || 0
            this.open5 = true
        },
        handleSizeChange(val){
            this.queryParams.limit = val
            this.getList()
        },
        handleCurrentChange(val){
            this.pageshow = false;
            this.queryParams.page = val
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        anjuanPingce(){
            this.open3 = true
        },
        async showText(val){
            this.contentL = ''
            let pageid = ''
            let pageCount = ''
            if(val == 1 && this.identifyList[this.isIndex]){
                pageid = this.identifyList[this.isIndex].pageid
                pageCount = this.identifyList[this.isIndex].pageCount
            }else if(val == 2 && this.identifyList2[this.isIndex2]){
                pageid = this.identifyList2[this.isIndex2].pageid
                pageCount = this.identifyList2[this.isIndex2].pageCount
            }
            let data = await this.$axios.get(`${this.Global._baseUrl}?act=getYsbNeirong&pcId=${this.pcId}&startPage=${pageid}&yeshu=${pageCount}`)
            if(data.data){
                if(val == 1){
                    let arr = data.data
                    this.contentL = ''
                    arr.forEach(item => {
                        this.contentL += item.nr2 
                    })
                    this.open4 = true
                }else if(val == 2){
                    let arr = data.data
                    this.content = ''
                    arr.forEach(item => {
                        this.content += item.nr2
                    })
                    this.$forceUpdate()
                }
            }else{
                this.$message({
                    message: '暂无识别内容',
                    type: 'error'
                });
            }
        },
        showOpen4(content){
            this.contentL = content
            this.open4 = true
        },
        rightClick(item){
            if(item.states != 1){
                this.formR = item
                this.open6 = true
            }else{
                this.$message({
                    message: '该案卷已提交，不能再进行修改！',
                    type: 'error'
                });
            }
        },
        async editDangan(val){
            
            this.$refs["formR"].validate(valid => {
                if (valid) { 
                        this.$axios.get(`${this.Global._baseUrl}?act=setDangAnImg&pcId=${this.pcId}&fileName=${escape(this.formR.fileName)}&fileurl=${this.formR.pageid}&yeshu=${this.formR.pageCount}&isdelte=${val}`)
                        .then(res => {
                            if (res.data == 1) {
                                this.$message({
                                    message: '操作成功。请点击下面的"刷新页面"按钮，查看修改后的效果。！',
                                    type: 'success'
                                });
                                this.open6 = false
                            } else {
                                this.$message({
                                    message: '操作失败！',
                                    type: 'error'
                                });
                            }
                        })
                }
            })
        },
        async editDanganYz(val){
            this.$refs["formR"].validate(valid => {
                if (valid) {
                        axios({
                            timeout: 3600000, // 单位：毫秒（6 分钟）
                            method: 'post',
                            url: this.baseUrl+`/yz/setDangAnImg`,
                            headers: { // 添加请求头
                                "Content-Type": "application/json" // 明确声明为 JSON 格式
                            },
                            data: {
                                pcId:this.pcId,
                                fileName:this.formR.name,
                                fileurl:this.formR.qishiye,
                                yeshu:this.formR.pageCount,
                                isdelte:val
                            }
                        })
                        .then(res => {
                            console.log(res,2522)
                            if (res.data.code == 0) {
                                this.$message({
                                    message: '操作成功。请点击下面的"刷新页面"按钮，查看修改后的效果。！',
                                    type: 'success'
                                });
                                this.open6Yz = false
                            } else {
                                this.$message({
                                    message: '操作失败！',
                                    type: 'error'
                                });
                            }
                        })
                        .catch(error => {
                            this.$message({
                                message: error.data.msg ? error.data.msg : '解析失败，请重试！',
                                duration: 5000,
                                type: 'error'
                            });
                        });
                }
            })
        },
        zancunYz(){
            axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: this.baseUrl+`/yz/getChongxinZhengli`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    pcId:this.pcId
                }
            })
            .then(res => {
                console.log(res,2522)
                if (res.data.code == 0) {
                    this.$message({
                        message: '操作成功。请点击下面的"刷新页面"按钮，查看修改后的效果。！',
                        type: 'success'
                    });
                    this.getList()
                } else {
                    this.$message({
                        message: '操作失败！',
                        type: 'error'
                    });
                }
            })
            .catch(error => {
                this.$message({
                    message: error.data.msg ? error.data.msg : '解析失败，请重试！',
                    duration: 5000,
                    type: 'error'
                });
            });
        },
        sortTable(row, currentIndex) {
            // 确保输入的值在有效范围内
            let newPosition = parseInt(row.orderNum);
            if (isNaN(newPosition) || newPosition < 1) {
                newPosition = 1;
            } else if (newPosition > this.mlList.length) {
                newPosition = this.mlList.length;
            }
            
            // 调整到以0为基础的索引
            newPosition -= 1;
            
            // 如果位置没有变化，不做任何操作
            if (newPosition === currentIndex) {
                return;
            }
            
            // 从数组中移除当前行
            const [movedRow] = this.mlList.splice(currentIndex, 1);
            
            // 将行插入到新位置
            this.mlList.splice(newPosition, 0, movedRow);
            
            // 更新所有行的orderNum值以反映新顺序
            this.mlList.forEach((item, index) => {
                item.orderNum = index + 1;
            });
        },
        
        // 其他现有方法...
        handleAddMulu(row, index) {
            this.$prompt('题名', '添加文书', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
                // inputErrorMessage: '邮箱格式不正确'value
            }).then(({ value }) => {
                // 添加新行时设置正确的orderNum值
                const newRow = {
                    orderNum: this.mlList.length + 1,
                    title: value,
                    // 其他属性...
                };
                this.mlList.splice(index + 1, 0, newRow);
                
                // 更新所有行的orderNum值
                this.updateorderNumValues();
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });       
            });
        },
        
        handleDeleteMulu(index) {
            this.$confirm("确定要删除这条目录吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
            })
            .then(() => {
                this.mlList.splice(index, 1);
                // 更新所有行的orderNum值
                this.updateorderNumValues();
            })
            .catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消操作"
                });
            });
        },
        
        updateorderNumValues() {
            this.mlList.forEach((item, index) => {
                item.orderNum = index + 1;
            });
        },
        GoUp(i){
            console.log(i,133)
            if(i==0){
                this.$message.error('当前问题为第一个，不能前移。');
                return false;
            }
            //this.move(this.mlList, i - 1, i);
            // 使用 this.$set 确保响应式更新
            this.$set(this.mlList, i, this.mlList.splice(i - 1, 1, this.mlList[i])[0]);
        },
        Godown(i){
            console.log(i,141)
            if(i==this.mlList.length-1){
                this.$message.error('当前问题为最后一个，不能后移。');
                return false;
            }
            //this.move(this.mlList, i, i+1);
            // 使用 this.$set 确保响应式更新
            this.$set(this.mlList, i, this.mlList.splice(i + 1, 1, this.mlList[i])[0]);
        },
        move(arr, index1, index2) {
            arr[index1] = arr.splice(index2, 1, arr[index1])[0];
            return arr;
        },
    }
}
</script>


<style scoped>
.nr{position: relative;}
.beizhu{color: #ff0000;}
.shibieW{width: 100%; overflow: hidden;}
.shibie{float: left; width: calc((100% - 30px) / 2 ); height: 70vh;}
.menus{ width: 200px;  height: calc(100% - 45px); float: left;}
.shibie >>> .el-scrollbar { width: 100%; height: 100%;}
.shibie >>> .el-scrollbar__bar.is-horizontal{opacity: 0;}
.shibie >>> .el-scrollbar__wrap { overflow-y: auto !important; overflow-x: hidden;}
.shibie >>> .el-scrollbar__view{min-height: 100%;}
.right .imgW >>> .el-scrollbar__view{ background: #eef3f9;}
.shibieW .right{float: right;}
.shibie h3{background: #fff; width:100%; color:#000; border-bottom: solid 1px #ddd; line-height: 36px; margin-bottom: 8px;}
.shibie ul{width: 180px;margin-right: 10px;}
.shibie ul li{line-height: 36px; width: 100%; overflow: hidden; white-space: normal; text-overflow: ellipsis; cursor: pointer;}
.shibie ul li.active{color:#1890ff;}
.imgW{width: calc(100% - 214px);  height: calc(100% - 45px);float: right;}
.imgW img{ width: 100%;}
.imgW h3{border-bottom: none; padding:10px 0;}
.imgW h3 span{ border-left: solid 4px #1890ff; line-height: 1; padding-left: 6px;display: block;}
.imgW >>> .el-form{ padding: 10px 0 10px 10px; width: calc(100% - 45px);}
.bigimg{width: 100%;}
.pcTk >>> .el-dialog{height: 90vh;}
.pcTk2 >>> .el-dialog{max-height: 96vh;}
.imgW >>> .el-input.is-disabled .el-input__inner,.imgW >>> .el-textarea.is-disabled .el-textarea__inner  { color: #606266;}
.shangchuan >>> .el-upload,.shangchuan >>> .el-upload-dragger {width:100%;}
/* .newTk >>> .el-loading-spinner .el-loading-text{color:#fff;}
.newTk >>> .el-loading-spinner .path{stroke: #FFF;} */
.load{position: absolute;
    z-index: 2;
    background: #fff;
    width: 100%;
    height: 100%;
    text-align: center;}
.load img{width: 40%; max-width: 240px;}
.tzbox >>> .content-container{min-width: 600px !important;height:auto !important;}
.tzbox >>> .vdr.active::before{ display: none;}

.shuoming{color:#000; padding: 0 40px 20px;}
.shuoming h2{text-align: center; line-height: 50px;}
.shuoming p{font-size: 16px; line-height: 34px; font-weight: bold;}
.content >>> .el-date-editor.el-input,.content >>> .el-date-editor.el-input__inner{width:140px;}

.anjuan{width: 100%; overflow: hidden;}
.left2{float: left; width: 200px; height: 68vh;background: #eee; border-radius: 2px; overflow-y: auto;}
.right2{float: right;width: calc(100% - 220px); height: 68vh;} 
.mulu{width:100%;height:calc(100% - 45px); overflow-y: auto;}
.btn{width:100%; text-align: right; margin-top: 10px;}
.left2 p {text-align: center;margin-top:10px;}

.left2 p img{width: 90%; margin:0 5%;}
.left2 p span{ width:100%; display: block; text-align: center; color: #000;}
:btnS span{cursor: pointer;}
:btnS span:hover{background:#eee;}
</style>